import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    showUpgradePlanModal: false,
  },
  reducers: {
    handleToggleShowUpgradePlanModal: (state, action: PayloadAction<boolean>) => {
      if (state.showUpgradePlanModal && action.payload) return;
      state.showUpgradePlanModal = action.payload;
    },
  },
});

export const { handleToggleShowUpgradePlanModal } = uiSlice.actions;

export default uiSlice.reducer;
